import React, { useEffect, useState } from 'react';
import { Button } from "bootstrap-4-react/lib/components";
import { Accordion } from "react-bootstrap";
import DatePickerComponent from '../common/DatePickerComponent';
import Cards from "../../assets/images/cards.png";

const InvoicePayment = () => {
    const [formData, setFormData] = useState({});

    useEffect(() => {
        setFormData({});
    }, []);

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Secure Payment Page
                    <div></div>
                    <div className="top_right_button_container">
                        <Button
                            className="cus-primary-transparent-btn top-btn"
                            id="hdb"
                        >
                            Back
                        </Button>
                    </div>
                </div>
                <div className="cus-page-content-sec">
                    <div className="incomingAccordion accordion pt-2">
                        <div className='row fontFix'>
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="input-label-txt">Invoice Number</div>
                                <div className="input-box">
                                    <input
                                        value={formData?.itemName}
                                        name={"itemName"}
                                        className="form-control"
                                        maxLength={100}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                <div className="input-label-txt">Total Amount Due</div>
                                <div className="input-box">
                                    <input
                                        value={formData?.itemName}
                                        name={"itemName"}
                                        className="form-control"
                                        maxLength={100}
                                    />
                                </div>
                            </div>
                            <div className='col-lg-7'>
                                <Accordion
                                    defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
                                    alwaysOpen={true}
                                    className='paymentAccordion'
                                >
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Billing Info</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="row addressForm pl-3 pr-3">
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Company Name
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        First Name <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Last Name <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Address 1 <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Address 2 <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        City <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        State <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Zip/Postal Code <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Country <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <select className="form-control">
                                                            <option>Select</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Email Address <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Phone #
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                            <div className='col-lg-5'>
                                <Accordion
                                    defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
                                    alwaysOpen={true}
                                    className='paymentAccordion'
                                >
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Payment Info</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="row addressForm pl-3 pr-3">
                                                <div className="col-lg-12 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Card Number <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Expiration Date <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <DatePickerComponent dateField={new Date()} handleDateChange={() => { }} fieldName={"expirationDate"} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-label-txt">
                                                        Security Code (CVV) <span className="require-field">*</span>
                                                    </div>
                                                    <div className="input-box">
                                                        <input
                                                            value={formData?.itemName}
                                                            name={"itemName"}
                                                            className="form-control"
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 col-md-6 col-sm-12 mb-3">
                                                    <div className="input-box flexPayment">
                                                        <img alt="" src={Cards} style={{ maxWidth: '200px' }} />
                                                        <button type="button" name="submitBtn" className="btn submitPayment" id="submitBtn">Submit Payment</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default InvoicePayment;